import React, { Component } from 'react';
import styled from 'styled-components';
import { func } from 'prop-types';
import MenuIcon from '@material-ui/icons/MoreVert';
import { fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';

const KebabMenuIcon = styled(MenuIcon).withConfig({ componentId: 'sc-ryctp8-0' })`
  cursor: pointer;
  font-size: ${fontSize.extraLarge};
  align-items: center;
  color: ${colors.crunchBerry};
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClick: func;
};

class KebabMenu extends Component<Props> {
  render = () => {
    const { onClick } = this.props;

    return <KebabMenuIcon onClick={onClick} />;
  };
}

export default KebabMenu;
